module.exports = __webpack_public_path__ + "img/info.3104e695.svg";